import { LogoFocal } from '../../../utils/icons.jsx';
import './index.css'

const HeaderPrices = ({generatePDF}) => {
    return <header id='header_prices' className={generatePDF ? 'header_prices custom-pdf': 'header_prices'}>
        <LogoFocal />
    </header>
}

export default HeaderPrices;